
import useWeb3Forms from "@web3forms/react"; // Make sure to install it
import { useState } from "react";
import { useForm } from "react-hook-form";

const ContactSection = () => {
  const { register, handleSubmit, reset } = useForm();
  const [result, setResult] = useState(null);

  const accessKey = "05b7421c-0cec-4f07-bcca-972619dcfb06"; // Replace with your actual Web3Forms access key

  const { submit: onSubmit } = useWeb3Forms({
    access_key: accessKey,
    settings: {
      from_name: "Spectrum Nurturing Academy",
      subject: "New Contact Message",
    },
    onSuccess: (msg, data) => {
      setResult({ type: "success", message: msg });
      reset();
    },
    onError: (msg, data) => {
      setResult({ type: "error", message: msg });
    },
  });

  return (
    <section className="py-16 px-4 mt-28">
      <div className="max-w-2xl mx-auto bg-gradient-to-br from-orange-200 to-pink-300 rounded-3xl shadow-xl p-4 lg:p-20">
        <h2 className="text-2xl font-bold mb-6 text-center">Let's Get Started</h2>

        <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex gap-4">
            <input
              type="text"
              placeholder="First Name"
              {...register("firstName", { required: true })}
              className="w-1/2 px-4 py-2 rounded bg-white border border-gray-300"
            />
            <input
              type="text"
              placeholder="Last Name"
              {...register("lastName", { required: true })}
              className="w-1/2 px-4 py-2 rounded bg-white border border-gray-300"
            />
          </div>
          <input
            type="email"
            placeholder="Email"
            {...register("email", { required: true })}
            className="w-full px-4 py-2 rounded bg-white border border-gray-300"
          />
          <input
            type="text"
            placeholder="Phone"
            {...register("phone")}
            className="w-full px-4 py-2 rounded bg-white border border-gray-300"
          />
          <textarea
            placeholder="Message"
            {...register("message", { required: true })}
            className="w-full px-4 py-2 rounded bg-white border border-gray-300"
            rows="3"
          />
          <button
            type="submit"
            className="bg-orange-500 text-white px-6 py-2 rounded-full font-semibold shadow hover:bg-orange-600 transition"
          >
            Submit
          </button>
        </form>

        {result && (
          <div className={`mt-4 text-center ${result.type === "success" ? "text-green-600" : "text-red-600"}`}>
            {result.message}
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactSection;
